<template>
    <div class="employee-ratings">
        <employee-ratings-section v-for="group in ratingGroups" :key="'group_' + group.id" :group="group" @updateRatings="reboot" ></employee-ratings-section>
        <div v-if="ratingGroups.length == 0">
            No ratings available.
        </div>
    </div>
</template>

<script>
    import EmployeeRatingsSection from "./EmployeeRatingsSection";
    export default {
        name: "EmployeeRatings",

        components: {
            EmployeeRatingsSection
        },

        props: {
            pid:{type: Number}
        },

        data() {
            return {
                ratingGroups: {}
            };
        },

        mounted(){
            this.loadRatings();
        },

        methods: {
            loadRatings(){
                axios.get("/api/employee/" + this.pid + "/ratings")
                    .then((pack) => this.updateRatings(pack));
            },
            updateRatings(pack){
                if(pack.data.success){
                    this.ratingGroups = pack.data.data;
                }
            },
            reboot(){
                this.ratingGroups = {};
                this.loadRatings();
            }
        }
    }
</script>
